;(function() {
/* @ngInject */
function BusinessSubjectsSearchController(ModalBusinessSubjects, BusinessSubjectSearchEngine, _, $window, $compile, $scope, $document, $filter, $anchorScroll, $location, $timeout) {
  let vm = this;
  const SearchResultsLimit = 19;
  const SearchDebounceMilliseconds = 125;

  vm.input = { value: "", isFocused: false };
  vm.onFocus = onFocus;
  vm.onBlur = onBlur;
  vm.onChange = onChange;
  vm.onKeydown = onKeydown;
  vm.onListClick = onListClick;
  vm.results = [];
  vm.resultsNonEmpty = resultsNonEmpty;
  vm.clearText = clearText;

  var content = $filter("translate")("zalozenieZivnosti.krok1.placeholder");
  vm.icoPlaceholder = "";

  var i=0;
  let searchPromise;

  var timer = setInterval(function(){
    if(i<content.length)
      vm.icoPlaceholder += content[i];
    else clearInterval(timer);
    i++;
    $scope.$apply();
  }, 100);

  let body = $document.find("body").eq(0);
  let bgElem = $compile("<div class='modal-backdrop' ng-show='vm.input.isFocused' ng-click='vm.onBlur()'></div>")($scope);
  body.append(bgElem);

  function clearText() {
    vm.input.value = "";
    cancelScheduledSearch();
    let element = $window.document.getElementById('btn_search_bar');
    if(element)
      element.focus();
    filter();
  }

  function onFocus(scrollLocation) {
    vm.input.isFocused = true;
    body.addClass("modal-open modal-open-without-fixed");

    let offsetScroll = 0;
    if (window.matchMedia('(min-width: 45em)').matches)
      offsetScroll = 170;
    else offsetScroll = 50;

    $('html, body').animate({
      scrollTop: $("#" + scrollLocation).offset().top - offsetScroll
    }, 500);
  }

  function onBlur() {
    vm.subjectId = 0;

    for(let i = 0; i < vm.results.length; i++) {
      if(vm.results[i].isShownForm)
        vm.subjectId = vm.results[i].id;
    }

    if(vm.subjectId !== 0) {
      $("#errorObject-" + vm.subjectId).show();
      $('.result_tbl_scroll').animate({
        scrollTop: $("#object-" + vm.subjectId)[0].getBoundingClientRect().top - $(".result_tbl")[0].getBoundingClientRect().top - 100
      }, 500);
    } else {
      vm.input.isFocused = false;
      body.removeClass("modal-open modal-open-without-fixed");
    }
  }

  function onChange() {
    cancelScheduledSearch();
    searchPromise = $timeout(function() {
      searchPromise = null;
      filter();
    }, SearchDebounceMilliseconds);
  }

  function cancelScheduledSearch() {
    if (searchPromise) {
      $timeout.cancel(searchPromise);
      searchPromise = null;
    }
  }

  $scope.$on("$destroy", cancelScheduledSearch);

  function onKeydown(e) {
    if (e.keyCode == 27) {
      vm.input.isFocused = false;
    }
  }

  function onListClick() {
    ModalBusinessSubjects.open({
      subjectGroups: vm.subjectGroups,
      select: vm.select,
      deselect: vm.deselect,
      isSelected: vm.isSelected,
      founders: vm.founders,
      selected: vm.selected,
      isChangeCompany: vm.isChangeCompany,
      lang: vm.lang
    });
  }

  function resultsNonEmpty() {
    return !_.isEmpty(vm.results);
  }

  function filter() {
    let v = vm.input.value.trim();
    if (v !== "") {
      vm.results = collectSearchResults(v);
      let all = vm.selected ? vm.subjects.concat(vm.selected) : vm.subjects;

      let id =  _.min(_.map(all, function(e){return e.id}));

      vm.results.push({id: id-1,
        name: vm.input.value,
        type: "3",
        tags:"",
        price:0.0,
        category:"",
        category2:"",
        category3: "",
        content:"",
        packageTags: "",
        nameEN: vm.input.value,
        contentEN: ""});
    }
    else {
      vm.results = [];
    }
  }

  function collectSearchResults(v) {
    return BusinessSubjectSearchEngine
      .search(v, SearchResultsLimit)
      .map(result => result.subject);
  }
}

angular.module("firmaren")
  .component("businessSubjectsSearch", {
    templateUrl: "/app/shared/business-subjects-search/business-subjects-search.html",
    controller: BusinessSubjectsSearchController,
    controllerAs: "vm",
    bindings: {
      subjects: "=",
      subjectGroups: "=",
      select: "=",
      deselect: "=",
      isSelected: "=",
      selected: "=",
      founders: "=",
      isChangeCompany: "=",
      lang: "="
    }
  });
}());
